/** admin/users — KEYS. */
export const adminUsersKeys = {
  all: () => ['admin', 'users'] as const,
  lists: () => [...adminUsersKeys.all(), 'list'] as const,
  list: (filters: Record<string, unknown>) => [...adminUsersKeys.lists(), filters] as const,
};
